import { Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { IDeviceContract } from '@nx-fe/services';
import { filter } from 'rxjs/operators';
import { DeviceContextService } from 'sspapp/services/device-context.service';
import { DeviceService } from '../../device-overview/services/device.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent {
  @Input()
  public device: IDeviceContract;
  public id: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private deviceContextService: DeviceContextService,
    private deviceService: DeviceService
  ) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.id = this.route.snapshot.parent.params.id;
      this.deviceService.actionListener$.subscribe(f => {
        this.loadDevice();
      });
    });
  }

  loadDevice() {
    setTimeout(() => {
      this.deviceContextService.getDeviceSsp(this.id).then((device: IDeviceContract) => {
        this.device = device;
      });
    }, 500);
  }
}
